import React from "react";

const FormSubSectionPreview = props => {
  const {children, title, show} = props;
  return show ? (
    <div className="row my-3">
      <div className="col-12">
        <h6 className="text-blue-cermaq my-3">{title}</h6>
      </div>
      <div className="col-12">{children}</div>
    </div>
  ) : (
    <></>
  );
};

export default FormSubSectionPreview;
